import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json';
import SweetAlert from "sweetalert2";
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Typography } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import Tab2 from './Tab2';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import { SimulationIjaraDto } from '../../../../../Models/SimulationIjarahDto';
import { useAgence } from '../../../../../AgenceContext';
import { PrintTabamount } from '../../../../../utilitaires/PrintTabamort';
import { PrintTabamountIjara } from '../../../../../utilitaires/printTabamortIjara';

const SimulationIjarah = () => {
  // USER SESSION
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  
  // USER TOKEN
  const authHeader = useAuthHeader();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  // États des boutons
  const [ajoutActve, setAjoutActif] = useState(false);
  const [modifActve, setModifActve] = useState(true);
  const [enregActve, setEnregActve] = useState(true);
  const [supActive, setSupActive] = useState(true);
  const [impActive, setImpActive] = useState(true);
  const [actuActive, setActActive] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [consulActive, setConsulActive] = useState(false);

  const [sbmit, setSbmit] = useState("");
  const [data, setData] = useState([]); // Tableau des échéances
  const Branch = useAgence();

  // Colonnes du tableau des échéances
  const columns: ColumnsType<any> = [
    {
      title: 'N° Échéance',
      dataIndex: 'NumeroEch',
      key: 'NumeroEch',
      width: 120,
      align: 'center',
      render: (text: any) => <span style={{ fontWeight: 500, color: '#1890ff' }}>{text}</span>,
    },
    {
      title: 'Date Échéance',
      dataIndex: 'DateEcheance',
      key: 'DateEcheance',
      width: 150,
      align: 'center',
      render: (text: any, record: any) => (
        <span style={{ fontWeight: 500 }}>
          {record.DateEcheance ? (new Date(record.DateEcheance.substring(0, 10))).toLocaleDateString("fr-FR") : ''}
        </span>
      ),
    },
    {
      title: 'Capital Initial',
      dataIndex: 'CapitalInitial',
      key: 'CapitalInitial',
      width: 160,
      align: 'right',
     render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Part Recup. Bien',
      dataIndex: 'PartRecuperationBien',
      key: 'PartRecuperationBien',
      width: 160,
      align: 'right',
      render: (text: any) => Number(text ?? 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 }),
    },
    {
      title: 'Charge',
      dataIndex: 'PartCharge',
      key: 'PartCharge',
      width: 100,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Marge Locative',
      dataIndex: 'MargeLocative',
      key: 'MargeLocative',
      width: 160,
      align: 'right',
      render: (text: any) => Number(text ?? 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 }),
    },
     
    {
    title:'TVA',
      dataIndex: 'TVA',
      key: 'TVA',
      width: 120,
      align: 'right',
      render: (text: any) => Number(text ?? 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 }),
    },
    {
      title: 'Loyer TTC',
      dataIndex: 'LoyerTTC',
      key: 'LoyerTTC',
      width: 180,
      align: 'right',
      render: (text: any) => Number(text ?? 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 }),
    },
    {
      title: 'Solde Restant TTC',
      dataIndex: 'SoldeRestantTTC',
      key: 'SoldeRestantTTC',
      width: 180,
      align: 'right',
      render: (text: any) => Number(text ?? 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 }),
    },
  ];

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false);
    setModifActve(true);
    setEnregActve(true);
    setSupActive(true);
    setImpActive(true);
    setActActive(true);
    setAnnulActive(true);
    setConsulActive(false);
  }

  function handleAnulle() {
    setImpActive(true);
    setData([]);
    form.resetFields();
    initialiazeButton();
  }

  function cunsultButton() {
    setAnnulActive(false);
    setModifActve(false);
  }

  function modifButton() {
    setSbmit("update");
    setModifActve(true);
    setAjoutActif(true);
    setEnregActve(false);
    setConsulActive(true);
    setImpActive(true);
  }

  function AfficheButton() {
    setSbmit("Afficher");
    setModifActve(true);
    setAjoutActif(true);
    setEnregActve(false);
    setConsulActive(true);
  }

  // Récupération des infos du type Ijarah pour frais éventuels
  function consultTypecard() {
    if (form.getFieldValue("CodeIjara") == null) {
      SweetAlert.fire({ title: "Svp renseigner le Code du type de Ijara", icon: "warning" });
    } else {
      let data = form.getFieldValue("CodeIjara");

      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsIjarah,
          headers: {
            'CypherCodeIjara': Crypter.encrypt(data),
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          },
        };

        axios.request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              console.log(res);
              if (res.StatutCode == 200) {
                const frais = res.Result.Table1[0]?.MontantFrais || 0;
                form.setFieldValue("CodeFrais", res.Result.Table4.map((x: any) => x.CODOPE));
                form.setFieldValue("MontantFrais", frais);
              } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: "Error", text: String(error), icon: "error" });
          });
      }
    }
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (<span id='Tab'><UserOutlined />Information du financement</span>),
      children: <Tab1 form={form} disabled={ajoutActve} GetTypeCard={consultTypecard} />,
    },
    {
      key: '2',
      label: (<span id='Tab'><UserOutlined />Frais de service</span>),
      children: <Tab2 form={form} />,
    }
  ];

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + "");
    });
    SweetAlert.fire({
      title: "Veuillez remplir tous les champs obligatoires",
      text: errors.toString().replaceAll(',', " - "),
      icon: 'warning',
      confirmButtonText: 'OK'
    });
  };

  const onFinish = async (values: any) => {
    const SimulationIjarah: SimulationIjaraDto = {
      CodeSimul: values.CodeSimul,
      CodeIjara: values.CodeIjara,
      TypeIjara: values.TypeIjara || "IMB",
      CoutAcquisitionBien: Number(values.CoutAcquisitionBien) || 0,
      ValeurResiduelle: Number(values.ValeurResiduelle) || 0,
      MargeLocative: Number(values.MargeLocative) || 0,
      DureeContratMois: Number(values.DureeContratMois) || 0,
      DureeDiffereMois: Number(values.DureeDiffereMois) || 0,
      NombreEch: Number(values.NombreEch) || 0,
      Periodicite: values.Periodicite || "M",
      Numcli: values.Numcli,
      MontantCharge: Number(values.MontantCharge) || 0,
      Nomcli: values.lib_Numcli || values.Nomcli,
      DatePremEch: values.DatePremEch,
      CodeUti: user.coduti
    };

    let data = Crypter.encrypt(JSON.stringify(SimulationIjarah));

    if (sbmit === "Apercu") {
      setLoading(true);
      console.log("reponse",SimulationIjarah);
      SimulationIjarah.CodeIjara = SimulationIjarah.CodeIjara + '-' + '' + values.lib_CodeIjara;
      PrintTabamountIjara(
        user.coduti ?? '',
        user.codage ?? '',
        Branch.agence?.LIBELLE ?? '',
        Branch.agence?.BANQUE ?? '',
        Branch.agence?.TELEPH ?? '',
        Branch.agence?.NUMREG ?? '',
        Branch.agence?.LICENCE ?? '',
        Branch.agence?.NUMREG ?? '',
        Branch.agence?.BPOSTE ?? '',
        Branch.agence?.VILLE ?? '',
        user.nomuti ?? '',
        values.lib_Periodicite,
        SimulationIjarah
      );
      setLoading(false);
      setSbmit("add");
    }
    else if (sbmit === "Afficher") {
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.SimulationIjarah,
        headers: {
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            console.log(res);
            if (res.StatutCode == 200) {
              setData(res.Result.Table as any);
              setImpActive(false);
              setSbmit("add");
            } else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
        });
    }
    else if (sbmit === "add") {
      SweetAlert.fire({
        title: "Enregistrement de la simulation de financement",
        text: "Voulez-vous enregistrer cette simulation de Financement?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true);
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.CreateSimulationIjarah,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                  initialiazeButton();
                  form.resetFields();
                  setData([]);
                  setImpActive(false);
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                } else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error);
              SweetAlert.fire({ title: String(error), icon: "error" });
            });
        }
      });
    }
    if (sbmit === "update") {
      SweetAlert.fire({
        title: "Mise à jour de la simulation de financement",
        text: "Voulez-vous mettre à jour la simulation de Financement " + SimulationIjarah.CodeSimul + ' ?',
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true);
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.UpdateSimulationIjarah,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                  initialiazeButton();
                  form.resetFields();
                  setData([]);
                  setImpActive(false);
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                } else {
                  SweetAlert.fire({ title:res.Message, text: res.Result, icon: "warning" });
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error);
              SweetAlert.fire({ title: String(error), icon: "error" });
            });
        }
      });
    }
  };

  function modif() {
    modifButton();
  }

  function consult() {
    let codeSimul = form.getFieldValue("CodeSimul");
    if (!codeSimul) {
      SweetAlert.fire({ title: "Veuillez saisir un Code Simul", icon: "warning" });
      return;
    }
    
    let data = Crypter.encrypt(codeSimul);

    if (data.length != 0) {
      setLoading(true);
      form.resetFields();
      form.setFieldValue('CodeSimul', codeSimul);
      
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadSimulationIjarah,
        headers: {
          'CypherCode': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              form.setFieldsValue(res.Result.Table2[0]);
              form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table2[0].DatePremEch));
              setData(res.Result.Table1 as any);
              consultTypecard();
              cunsultButton();
              setImpActive(false);
            } else {
              SweetAlert.fire({ title: res.Message, icon: "warning" });
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: String(error), icon: "error" });
        });
    }
  }

  const SetStart = () => {
    setSbmit("add");
    setAjoutActif(true);
    setEnregActve(false);
    setAnnulActive(false);
    setConsulActive(true);
  }

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>SIMULATION du financement Ijarah</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }}>
        <Form
          disabled={!ajoutActve}
          autoComplete="off"
          labelAlign='left'
          form={form}
          name="dynamic_form_complex"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block>
                  Consulter
                </Button>
                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block>
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" onClick={AfficheButton} htmlType="submit" block>
                  Afficher
                </Button>
                <Button size='large' className='bt_add' htmlType="submit"
                  onClick={() => { setSbmit("Apercu"); }}
                  disabled={impActive} type="ghost" block>
                  Aperçu
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block>
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            {/* Onglets principaux (Tab1 + Tab2) */}
            <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
            
            {/* Tableau des échéances en dessous des onglets */}
            <Box fontStyle="inherit" className='border-left tabElementsimFin' sx={{ width: '85%', mt: 19 }}>
              <Spin spinning={loading}>
                <Form disabled={true}>
                  <Table
                    size='small'
                    columns={columns}
                    dataSource={data}
                    scroll={{ y: 250 }}
                    pagination={false}
                    bordered
                    style={{ backgroundColor: '#ffffff', borderRadius: '6px' }}
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                  />
                </Form>
              </Spin>
            </Box>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default SimulationIjarah;